import config from './config';
import api from './api';

const SavedMessagesServices = {
  deleteAllMessage: async (data, options) => {
    const res = await api.request({
      method: config.endpoints.savedMessages.deleteAllMessage.method,
      path: config.endpoints.savedMessages.deleteAllMessage.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  deleteMessage: async (data, options) => {
    const res = await api.request({
      method: config.endpoints.savedMessages.deleteMessage.method,
      path: config.endpoints.savedMessages.deleteMessage.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  editMessage: async (data, options) => {
    const res = await api.request({
      method: config.endpoints.savedMessages.editAllMessage.method,
      path: config.endpoints.savedMessages.editAllMessage.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  getListMesage: async (data, options) => {
    const res = await api.request({
      method: config.endpoints.savedMessages.getListMessage.method,
      path: config.endpoints.savedMessages.getListMessage.path,
      host: config.host,
      data,
      options,
    })
    return res
  },

  saveMessage: async (data, options) => {
    const res = await api.request({
      method: config.endpoints.savedMessages.saveMessage.method,
      path: config.endpoints.savedMessages.saveMessage.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
  saveMultiple: async (data, options) => {
    const res = await api.request({
      method: config.endpoints.savedMessages.saveMultiple.method,
      path: config.endpoints.savedMessages.saveMultiple.path,
      host: config.host,
      data,
      options,
    })
    return res
  },
}
export default SavedMessagesServices